import { AppActionTypes } from './AppActions';
const createHistoryAction = method => location => ({
  type: AppActionTypes.HISTORY_METHOD_CALLED,
  payload: {
    method,
    args: [location]
  }
});
export const push = createHistoryAction('push');